import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, Dialog, DialogContent, DialogHeader, H2, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { activeAccount } from 'shared/domains/users';
import { Illustration } from './Illustration';
export function FinishedDialog(props) {
    const { accountId } = props;
    const reloadPage = () => {
        activeAccount.set(accountId);
        window.location.reload();
    };
    return (<Dialog>
      <DialogHeader icon={<Falcon icon="building"/>} title={t({
            message: 'Company created',
            comment: 'Add company dialog - Finished state title',
        })}/>

      <DialogContent>
        <Box flexDirection="column" alignItems="center" gap="xl" pb="2xl">
          <Illustration />

          <Box flexDirection="column" style={{ textAlign: 'center' }}>
            <H2>
              <Trans comment="Add company dialog - Finished state title">Your new company is set up!</Trans>
            </H2>

            <Typography $appearance="100">
              <Trans comment="Add company dialog - Finished state description">
                Invite some co-workers and start collaborating immediately.
              </Trans>
            </Typography>
          </Box>

          <Box alignItems="center" gap="lg">
            <Button type="button" size="small" appearance="secondary" onClick={reloadPage}>
              <Trans comment="Close dialog button">Close</Trans>
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>);
}
